const AUTH_PASSWORD_PUBLIC_KEY = (process.env.REACT_APP_AUTH_PASSWORD_PUBLIC_KEY ?? '').trim();

function base64ToBytes(value: string): Uint8Array {
  const binary = window.atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

function bytesToBase64(value: ArrayBuffer): string {
  const bytes = new Uint8Array(value);
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return window.btoa(binary);
}

export function isAuthPasswordEncryptionAvailable(): boolean {
  return AUTH_PASSWORD_PUBLIC_KEY.length > 0 && Boolean(window.crypto?.subtle);
}

/**
 * RSA-OAEP(SHA-256) 전송 암호화. 공개키 미설정·암호화 실패 시 null을 반환해
 * 호출부가 기존 평문 필드로 fallback 할 수 있게 한다 (점진 롤아웃 안전장치).
 */
export async function encryptAuthPassword(value: string): Promise<string | null> {
  if (!isAuthPasswordEncryptionAvailable()) {
    return null;
  }

  try {
    const key = await window.crypto.subtle.importKey(
      'spki',
      base64ToBytes(AUTH_PASSWORD_PUBLIC_KEY),
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      false,
      ['encrypt']
    );

    const encrypted = await window.crypto.subtle.encrypt(
      { name: 'RSA-OAEP' },
      key,
      new TextEncoder().encode(value)
    );

    return bytesToBase64(encrypted);
  } catch {
    return null;
  }
}
